<template>
  <div id="modal" class="loading-modal" v-show="modalShown">
    <div class="cross_btn" @click="close()">
      <span class="css-cancel"></span>
    </div>
    <div id="swiper">
      <div class="swipe-parent">
        <div class="swiper-button-prev" slot="button-prev" :style="swiperButtonPrev"></div>
        <swiper ref="mySwiper" :options="swiperOptions">
          <swiper-slide v-for="(image, pageIdx) in imageList" :key="'swipe-page' + pageIdx">
            <div class="swipe_image">
              <img :src="image">
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-next" slot="button-next" :style="swiperButtonNext"></div>
      </div>
      <div class="swiper-pagination swiper-pagination-black" slot="pagination"></div>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import * as App from '../../../../../utils/App'

export default {
  name: 'ImageViewer',
  components: {
    swiper,
    swiperSlide
  },
  props: {
    imageList: Array,
    swiperOptions: Object
  },
  data () {
    return {
      modalShown: false,
      swiperButtonPrev: {
        background: 'url(' + this.getImage('common/left.svg') + ') no-repeat center center / contain'
      },
      swiperButtonNext: {
        background: 'url(' + this.getImage('common/right.svg') + ') no-repeat center center / contain'
      }
    }
  },
  watch: {
  },
  computed: {
  },
  methods: {
    /** モーダル表示 */
    showModal: function () {
      this.modalShown = true
    },
    close: function () {
      this.modalShown = false
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  }
}
</script>
<style lang="scss" scoped>
.loading-modal {
  z-index: 10000;
  background-color: rgba(0, 0, 0, 0.2);
  width: 100%;
  height: 100%;
  position: absolute;
}
// .image {
//     background: #FFFFFF;
//     max-width: calc(650px / 1.5);
//     // max-height: calc(880px / 1.5);
//     // width: 100%;
//     // height: 100%;
//     margin: 5% auto;
//     img {
//       width: 100%;
//       height: 100%;
//     }
// }
.image {
    max-width: calc(650px / 1.5);
    // max-height: calc(880px / 1.5);
    margin: 5% auto;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    img {
      width: 100%;
      height: 100%;
    }
}
.image-fit {
    background: initial;
    max-width: fit-content;
    max-height: fit-content;
    // width: 100%;
    // height: 100%;
    margin: 5% auto;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/main/js/payment/components/top/product/common/ImageSlide.vue